// extracted by mini-css-extract-plugin
export default {"TextInput":"TextInput_TextInput__Qdagh","TextInput__input":"TextInput_TextInput__input__bDiv3","TextInput__submit":"TextInput_TextInput__submit__YK-2S"};